// src/App.js
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./components/login/AdminLogin";
import Navbar from "./components/navbar/Navbar";
import MasterDashboard from "./components/dashboards/MasterDashboard";
import MoneyDashboard from "./components/dashboards/MoneyDashboard";
import GrainDashboard from "./components/dashboards/GrainDashboard";
import Footer from "./components/footer/Footer";
export default function App() {
    const [admin, setAdmin] = useState(JSON.parse(localStorage.getItem("admin")) || null);

    const handleLogout = () => setAdmin(null);

    // If not logged in, show the login (single-screen flow)
    if (!admin) {
        return <AdminLogin onLogin={setAdmin} />;
    }

    return (
        <Router>
            <Navbar admin={admin} onLogout={handleLogout} />
            <div className="container mt-4">
                <Routes>
                    <Route path="/" element={<MasterDashboard />} />
                    <Route path="/money" element={<MoneyDashboard />} />
                    <Route path="/grain" element={<GrainDashboard />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
            <Footer />
        </Router>
    );
}
